var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.087232 0 0 .073603 -7.4647 -3.1404)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-white",
    transform: "translate(85.573 42.667)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XLS",
    d: "m236.35 0h-234.67v234.67h42.667v-192h174.29l81.707 81.707v110.29h42.667v-128zm-236.35 405.33v-127.97h28.81v105.39h55v22.578zm153.17-130.23c20.11 0 35.523 6.3821 46.24 19.146 10.296 12.222 15.443 27.937 15.443 47.143 0 21.013-6.081 37.721-18.243 50.123-10.476 10.717-24.956 16.076-43.44 16.076-20.11 0-35.523-6.3821-46.24-19.146-10.296-12.222-15.443-28.178-15.443-47.866 0-20.591 6.081-37.088 18.243-49.491 10.536-10.657 25.017-15.985 43.44-15.985zm-0.0903 22.578c-10.416 0-18.454 4.335-24.113 13.005-5.1177 7.8271-7.6766 17.882-7.6766 30.164 0 14.209 3.0405 25.227 9.1216 33.054 5.7198 7.4056 13.306 11.108 22.759 11.108 10.356 0 18.424-4.3651 24.204-13.095 5.1177-7.7067 7.6766-17.882 7.6766-30.526 0-13.908-3.0405-24.776-9.1216-32.603-5.7198-7.4056-13.336-11.108-22.849-11.108zm190.83 36.035v65.296c-7.3454 2.4685-12.523 4.0942-15.534 4.8769-9.3323 2.4685-19.357 3.7028-30.074 3.7028-21.073 0-37.118-5.2983-48.137-15.895-12.222-11.68-18.333-27.967-18.333-48.859 0-24.023 7.5862-42.146 22.759-54.368 11.018-8.9108 25.89-13.366 44.614-13.366 16.015 0 30.917 2.9201 44.705 8.7603l-9.8441 22.488c-6.5025-3.2512-12.192-5.5241-17.069-6.8186-4.8769-1.2945-10.235-1.9417-16.076-1.9417-13.968 0-24.264 4.5457-30.887 13.637-5.5994 7.7067-8.3991 17.852-8.3991 30.435 0 15.112 4.2146 26.492 12.644 34.138 6.7433 6.1412 15.112 9.2119 25.107 9.2119 5.8402 0 11.379-0.99344 16.618-2.9803v-25.739h-22.036v-22.578z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogging);
export default __webpack_public_path__ + "static/media/logging.22304025913512cc14e36d06c8c1a1a6.svg";
export { ForwardRef as ReactComponent };